import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, Checkbox, TextField, Typography, FormControlLabel } from '@material-ui/core';

const categories = [
  {
    label: '接聽情形',
    options: ['親自接聽', '親友接聽', '無人接聽', '電話故障', '其他'],
  },
  {
    label: '口頭表達',
    options: ['表達清晰', '表達尚可', '語不清', '無法表達', '其他'],
  },
  {
    label: '健康情況',
    options: ['健康良好', '稍有病痛', '按時用藥', '定期門診', '其他'],
  },
  {
    label: '生活狀況',
    options: ['三餐定時', '餐不定時', '參與活動', '極少外出', '其他'],
  },
  {
    label: '親友互動',
    options: ['常有互動', '偶有互動', '很少互動', '從不互動', '其他'],
  },
  {
    label: '精神狀況',
    options: ['精神愉悅', '尚可', '精神不佳', '提不起勁', '其他'],
  },
  {
    label: '總評',
    options: ['好', '尚可', '不好', '其他'],
  },
];

const PhoneCheckTable = ({ onChange }) => {
  const [formData, setFormData] = useState(() => {
    const initialData = {};
    categories.forEach((category) => {
      initialData[category.label] = [];
    });
    return initialData;
  });

  const formatFormData = (formData) => {
    return Object.entries(formData)
      .filter(([_, value]) => (Array.isArray(value) && value.length > 0) || (typeof value === 'string' && value.trim() !== ''))
      .map(([key, value]) => {
        if (Array.isArray(value)) {
          return `${key}: ${value.join(', ')}`;
        }
        return `${key}: ${value}`;
      })
      .join('\n');
  };

  const handleOptionChange = (field, option, value) => {
    const newFormData = { ...formData };
    if (value) {
      if (!newFormData[field].includes(option)) {
        newFormData[field].push(option);
      }
    } else {
      newFormData[field] = newFormData[field].filter((o) => o !== option);
    }
    setFormData(newFormData);
    onChange(formatFormData(newFormData));
  };

  const handleOthersChange = (field, value) => {
    const newFormData = { ...formData };
    if (value) {
      if (newFormData[field]) {
        const index = newFormData[field].findIndex((o) => o.startsWith('其他-'));
        if (index !== -1) {
          newFormData[field][index] = `其他-${value}`;
        } else {
          newFormData[field].push(`其他-${value}`);
        }
      } else {
        newFormData.push(`其他-${value}`);
      }
    } else {
      if (newFormData[field]) {
        newFormData[field] = newFormData[field].filter((o) => !o.startsWith('其他-'));
      }
    }
    setFormData(newFormData);
    onChange(formatFormData(newFormData));
  };

  const handleAdditionalChange = (field, value) => {
    const newFormData = { ...formData };
    if (value) {
      newFormData[field] = value;
    } else {
      delete newFormData[field];
    }
    setFormData(newFormData);
    onChange(formatFormData(newFormData));
  };

  return (
    <Grid container spacing={2}>
      {categories.map((category, index) => (
        <Grid item xs={12} key={index}>
          <Typography variant="subtitle1">{category.label}</Typography>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            {category.options.map((option, idx) => (
              <span key={idx}>
                {option !== '其他' ? (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formData[category.label]?.includes(option)}
                        onChange={(e) => {
                          handleOptionChange(category.label, option, e.target.checked);
                        }}
                      />
                    }
                    label={option}
                  />
                ) : (
                  <TextField label="其他" onChange={(e) => handleOthersChange(category.label, e.target.value)} style={{ marginBottom: 16 }} />
                )}
              </span>
            ))}
          </div>
        </Grid>
      ))}
      <Grid item xs={12}>
        <TextField
          label="補充陳述"
          fullWidth
          multiline
          onChange={(e) => handleAdditionalChange('補充陳述', e.target.value)}
        />
      </Grid>
    </Grid>
  );
};

PhoneCheckTable.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default PhoneCheckTable;
